module.exports = __webpack_public_path__ + "img/login-img.546e9ab3.svg";